import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

export interface BusinessCentralState {
  hasIntegration: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: BusinessCentralState = {
  hasIntegration: false,
  isLoading: true,
  error: null,
};

export const checkBusinessCentralIntegration = createAsyncThunk(
  "businessCentral/checkIntegration",
  async () => {
    const { data } = await axios.get<{ has_integration: boolean }>(
      "/v1/integrations/business_central/status/",
    );
    return data.has_integration;
  },
);

const businessCentralSlice = createSlice({
  name: "businessCentral",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkBusinessCentralIntegration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkBusinessCentralIntegration.fulfilled, (state, action) => {
        state.hasIntegration = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(checkBusinessCentralIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to check integration";
      });
  },
});

export default businessCentralSlice.reducer;
